import React, { Component } from 'react';
import Chart from 'react-apexcharts';
import { formatIntegerWithCommas } from './formatIntegerWithCommas.js';
import { t } from 'ttag';

class AChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            series: [0], // Инициализируем с 0
            options: {
                chart: {
                    type: 'radialBar',
                    offsetY: -10,
                    animations: { // Добавляем настройки анимации графика
                        enabled: true,
                        easing: 'easeinout',
                        speed: 1000,
                        animateGradually: {
                            enabled: true,
                            delay: 500
                        },
                        dynamicAnimation: {
                            enabled: true,
                            speed: 500
                        }
                    }
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        hollow: {
                            margin: 0,
                            size: "70%",
                            background: "transparent"
                        },
                        track: {
                            background: "rgba(255, 255, 255, 0.25)",
                            strokeWidth: "80%",
                            dropShadow: {
                                enabled: !1,
                                top: -3,
                                left: 0,
                                blur: 4,
                                opacity: .12
                            }
                        },
                        dataLabels: {
                            name: {
                                fontSize: "16px",
                                color: "#fff",
                                offsetY: 30
                            },
                            value: {
                                offsetY: -20,
                                fontSize: "20px",
                                color: "#fff",
                                formatter: (val) => {
                                    const actualValue = this.props.series;
                                    if (this.state.animatingBack && val === Math.round(this.props.series / (this.props.seriest / 100))) {
                                        return formatIntegerWithCommas(actualValue);
                                    }
                                    return formatIntegerWithCommas(Math.round((this.props.seriest / 100) * (val / 100)));
                                }
                            }
                        }
                    }
                },
                fill: {
                    type: "fill",
                    colors: ["#52a74d"],
                    gradient: {
                        shade: "dark",
                        shadeIntensity: .15,
                        inverseColors: !1,
                        gradientToColors: ["#52a74d"],
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 65, 91]
                    }
                },
                colors: ["#fff"],
                stroke: {
                    dashArray: 3
                },
                labels: this.props.labels || [t`Total Sales`],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            height: 300
                        }
                    }
                }]
            },
            animatingBack: false
        };
        this.timeoutId = null;
    }

    componentDidMount() {
        const maxValue = 100;
        this.animateToMax(maxValue);
    }

    componentDidUpdate(prevProps) {
        const currentSSR = Math.round(this.props.series / (this.props.seriest / 100));
        const prevSSR = Math.round(prevProps.series / (prevProps.seriest / 100));

        if (prevProps.series !== this.props.series || prevProps.seriest !== this.props.seriest || prevProps.labels !== this.props.labels) {
            const maxValue = 100;
            this.animateToMax(maxValue);
        }

        let clr = ["#52a74d"];
        if (currentSSR > 30) clr = ["#d8b345"];
        if (currentSSR > 70) clr = ["#d2404e"];

        if (this.state.options.fill.colors[0] !== clr[0]) {
            this.setState(prevState => ({
                options: {
                    ...prevState.options,
                    labels: this.props.labels,
                    fill: {
                        ...prevState.options.fill,
                        colors: clr,
                        gradient: {
                            ...prevState.options.fill.gradient,
                            gradientToColors: clr,
                        }
                    }
                }
            }));
        }

        if (this.state.options.labels != this.props.labels) {
            this.setState(prevState => ({
                options: {
                    ...prevState.options,
                    labels: this.props.labels,
                }
            }));
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }

    animateToMax = (maxValue) => {
        this.setState({ series: [maxValue], animatingBack: false }, () => {
            this.timeoutId = setTimeout(() => {
                const actualSSR = Math.round(this.props.series / (this.props.seriest / 100));
                this.setState({ series: [actualSSR], animatingBack: true });
            }, 700);
        });
    };

    render() {
        return (
            <div className="donut" style={{ width: "100%" }}>
                <Chart options={this.state.options} series={this.state.series} type="radialBar" />
            </div>
        );
    }
}

export { AChart };